import { useMockData } from "../config/api";
import { mockRequest, request } from "../utils/request";

export enum ProductTechnologyEnum {
    Laser = "LASER",
    Punching = "PUNCHING",
    Combined = "COMBINED",
    Bending = "BENDING",
    Software = "SOFTWARE",
    Co2Laser = "CO2LASER",
    SolidStateLaser = "SOLIDSTATELASER",
    MarkingLaser = "MARKINGLASER",
    AquaCut = "AQUACUT",
    Shear = "TRUSHEAR",
    Automation = "AUTOMATION",
    TwoDLaserCutting = "2DLASERCUTTING",
    ThreeDLaserCutting = "3DLASERCUTTING",
    ThreeDPrinting = "3DPRINTING",
    Cooler = "COOLER",
    DiodeLaser = "DIODELASER",
    DiskLaser = "DISKLASER",
    FiberLaser = "FIBERLASER",
    PulsedLaser = "PULSEDLASER",
    Welding = "WELDING",
    ShortPulsedLaser = "SHORTPULSEDLASER",
    StorageSystem = "STORAGESYSTEM",
    LaserTubeCutting = "LASERTUBECUTTING",
    Electronics = "ELECTRONICS"
}

export type ProductTechnologyType = `${ProductTechnologyEnum}`;

export interface ProductType {
    nameOnLabel: string;
    productNo: string;
    technology: ProductTechnologyType;
    dateOfConstruction: string | null;
    locationCity: string | null;
    hasServiceContract: boolean;
    errorSources: string[];
}

export const getMachineList = async (): Promise<ProductType[]> => {
    if (useMockData) {
        return mockRequest(mockMachines);
    }
    return request<ProductType[]>("/servicecall/getproducts", { filterSubEquipments: true });
};

export const mockMachines: ProductType[] = [
    {
        nameOnLabel: "Quicksharp",
        productNo: "TWDEDEMO097",
        technology: "PUNCHING",
        dateOfConstruction: "2011/01/18",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "Vector Mark Compact 5",
        productNo: "TWDEDEMO043",
        technology: "MARKINGLASER",
        dateOfConstruction: "2009/11/25",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["TruControl"]
    },
    {
        nameOnLabel: "TruPunch 5000 Mittelformat",
        productNo: "TWDEDEMO008",
        technology: "PUNCHING",
        dateOfConstruction: "2007/11/09",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TRUMATIC 600 L (Mittelformat)",
        productNo: "TWDEDEMO003",
        technology: "COMBINED",
        dateOfConstruction: "2000/08/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"]
    },
    {
        nameOnLabel: "TruMatic 7000 Großformat",
        productNo: "TWDEDEMO009",
        technology: "COMBINED",
        dateOfConstruction: "2011/06/20",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC", "TruControl"]
    },
    {
        nameOnLabel: "BendMaster bis 60 kg Traglast",
        productNo: "TWDEDEMO025",
        technology: "BENDING",
        dateOfConstruction: "2004/09/03",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5050",
        productNo: "TWDEDEMO028",
        technology: "BENDING",
        dateOfConstruction: "2007/12/03",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5050",
        productNo: "TWDEDEMO027",
        technology: "BENDING",
        dateOfConstruction: "2007/05/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5085 (B23)",
        productNo: "TWDEDEMO075",
        technology: "BENDING",
        dateOfConstruction: "2016/02/12",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5130",
        productNo: "TWDEDEMO074",
        technology: "BENDING",
        dateOfConstruction: "2017/06/27",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5130",
        productNo: "TWDEDEMO033",
        technology: "BENDING",
        dateOfConstruction: "2015/04/27",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5130",
        productNo: "TWDEDEMO024",
        technology: "BENDING",
        dateOfConstruction: "2007/01/04",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5170",
        productNo: "TWDEDEMO093",
        technology: "BENDING",
        dateOfConstruction: "2019/05/03",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5170",
        productNo: "TWDEDEMO029",
        technology: "BENDING",
        dateOfConstruction: "2007/05/31",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5230 (B23)",
        productNo: "TWDEDEMO069",
        technology: "BENDING",
        dateOfConstruction: "2015/09/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 5320 (B23)",
        productNo: "TWDEDEMO071",
        technology: "BENDING",
        dateOfConstruction: "2015/02/19",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO077",
        technology: "BENDING",
        dateOfConstruction: "2017/10/11",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO076",
        technology: "BENDING",
        dateOfConstruction: "2017/10/10",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    },
    {
        nameOnLabel: "TruBend 7036",
        productNo: "TWDEDEMO032",
        technology: "BENDING",
        dateOfConstruction: "2009/06/08",
        locationCity: null,
        hasServiceContract: true,
        errorSources: ["MMC"]
    }
];
